export interface IMatomo {
    siteId: number;
    organizationDimensionId: number;
    registryDimensionId: number;
}
